import { render } from "./AppRequestForm.vue?vue&type=template&id=39f67b68&scoped=true&lang=pug"
import script from "./AppRequestForm.vue?vue&type=script&setup=true&lang=js"
export * from "./AppRequestForm.vue?vue&type=script&setup=true&lang=js"

import "./AppRequestForm.vue?vue&type=style&index=0&id=39f67b68&lang=scss&scoped=true"

import exportComponent from "/Users/edsonfer/Documents/dev-projects/node-projects/portal-gignet-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39f67b68"]])

export default __exports__